import { Serials } from './../../claims/out-pat-claims/out-pat-claims.service';
import { Component, Input, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '../../ng-bootstrap/index';

import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
//shared libs
import { ModalService, ToastService, SelectizeComponent, StepperService, StepperComponent } from '../../blocks';
import { AppCodeGroup, ControlsParams, CashierParms, UserSessionService, positiveNumber, UIAction, UISessionKeys, SharedDateService, StockModuleSettingsParms } from '../../shared';


//services
import { Total, PayedServices, CashierTrans, PayedReceipt, CashierTransService } from './cashier-trans.service';
import { CshCashierTransCheque, ChequeDetailComponent } from '../cheque-detail/cheque-detail.component';
import { CshCashierTransVisa } from '../visa-detail/visa-detail.component';
import { CshCashierTransCoupon } from '../coupon-detail/coupon-detail.component';
import { BankTransformer, BankTransformerService, cshBankTransformerLog } from '../../banks/Bank-Transformer/bank-transformer.service';
import { BankTransformerDiscountComponent } from '../bank-transformmer-discount/bank-transformmer-discount.commponent';
import { readTextFile } from '../../medical-recored/emr-general-methods';
import { NavigationExtras, Router } from '@angular/router';
import { DiscountServicesRequestComponent } from './discount-services-request/discount-services-request.component';
import { CshSettlement } from '../another-settlement/cshSettlements';
import { ElectroincInvoiceZatcaService, ElectroincInvoicData } from '../electroinc-invoice-zatca/electroinc-invoice-zatca.service';
import { LoyaltyPointsRedemptionPolicy, LoyaltyPointsRedemptionPolicyService } from '../../loyality-system/loyalty-points-redemption-policy/loyalty-points-redemption-policy.service';

@Component({
  selector: 'sanabel-cashierTrans',
  templateUrl: 'cashier-trans.component.html',
  styleUrls: ['cashier-trans.component.css'],
  providers: [BankTransformerService]
})

export class CashierTransComponent implements OnInit, OnDestroy {
  loading = false;
  showSave: number = 1;
  bankTransformerDetailArray: BankTransformer[] = [];

  showBankTrans: boolean = false;
  SettleBankTransformerValue: number = 0;
  @ViewChild('BankTrans') BankTrans: any;
  popupHeader: string;
  dynamicComponent: any;
  @ViewChild('popup') content: any;
  @ViewChild('DiscountServicesRequest') DiscountServicesRequest: any;
  saveSpinner(): void {
    this.loading = true;
  }
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('percentOrValueSelectize') percentOrValueSelectize: SelectizeComponent;
  @ViewChild('discountTypeSelectize') discountTypeSelectize: SelectizeComponent;
  @ViewChild('discountDiscriptionSelectize') discountDiscriptionSelectize: SelectizeComponent;
  @ViewChild('btnCtrl1') btnCtrl: any;
  @Input() stepperComponent: StepperComponent;
  @Input() myStepNumber: number;
  @Input() transType: number;
  @Input() popUpClose: any;
  confirmationPopupForm: UntypedFormGroup;
  getDataFlag: boolean = true;
  editCashierTrans: CashierTrans = <CashierTrans>{};
  bankTranFromerObj: BankTransformer = <BankTransformer>{};
  controlsParams: ControlsParams;
  cashierTransForm: UntypedFormGroup;
  showComnfirmationPopUp: number;
  calculatVatOnPayed: number;
  cashierParms: CashierParms = <CashierParms>{};
  private unsubscribe = new Subject();
  payedServices: PayedServices[] = [];
  @ViewChild('showVisa') visaCheckBox: ElementRef;
  @ViewChild('showCheque') chequeCheckBox: ElementRef;
  chequeDetailArray: CshCashierTransCheque[] = [];
  couponDetailArray: CshCashierTransCoupon[] = []
  visaDetailArray: CshCashierTransVisa[] = [];
  isVirtual: number;
  cashierCode: number;
  currencyCode: number;
  factor: number;
  userId: number;
  transDate: any;
  selectedPatient: any = <any>{};
  cshBannerData: any = <any>{};
  notPayedVisit = [];
  remainingFromOtherVisits: any = <any>{};
  notPayedServices = [];
  notPayedCouponServices = []
  notPayedItems = [];
  payedReceiptWithComnfirmation: any;
  totalServices: Total = <Total>{};
  totalItems: Total = <Total>{};
  chequeValue: number = 0;
  visaValue: number = 0;
  couponValue: number = 0;
  @ViewChild('popuppp') popuppp: any;
  @ViewChild('bankTransFromPopup') bankTransFromPopup: any;
  discountType: number = 1;
  pvCode: number;
  percentOrValue: number;
  discountVal: number;
  totalEnabledValue: number;
  totalEnabledPatPrice: number;
  activatePublicSaleDiscount: number = 2;
  PossibilityPartialPayment: number = 1;
  discounTypeObject: any = <any>{};
  percentOrValueObject: any = <any>{};
  offerDiscount: boolean = false;
  showDiscount: boolean = false;
  payWithDoc: boolean = false;
  memoSerial: number = 0;
  invoicePrintingOutPat: number = 2;
  cshSettlement: CshSettlement[] = [];
  showDollarRate: number;
  showDownPayment: boolean = false;
  showCopon: boolean = false;
  showLoyaltyPoint: boolean = false; 
  currentTrans: any;
  stockSettingsParms: StockModuleSettingsParms = {};
  mediclaModuleSettings: {};
  benf: any = <any>{};
  partialyPaymentPrev: number = 0;
  valueOfCashReceived: number

  jsonFormSetting: any = <any>{};
  totalPayedValue: number;
  constructor(
    private _cashierTransService: CashierTransService,
    public translate: TranslateService,
    private _ngbModal: NgbModal,
    private _router: Router,
    private _toastService: ToastService,
    private _userSessionService: UserSessionService,
    private _dateService: SharedDateService,
    private _BankTransformerService: BankTransformerService,
    private _fb: UntypedFormBuilder,
        private _LoyaltyPointsRedemptionPolicyService: LoyaltyPointsRedemptionPolicyService,
    private _ElectroincInvoiceZatcaService: ElectroincInvoiceZatcaService) {
    this.controlsParams = new ControlsParams(77, AppCodeGroup.Buttons, true);

  }

  documentLookupCode: number
  tableRowId: number;


  ngOnInit() {
    this.showDollarRate = this._userSessionService.globalmodulesSettings.showDollarRate ? this._userSessionService.globalmodulesSettings.showDollarRate : 2;
    this.getModuleSettings();

    this.currentDataBaseUsed = this._userSessionService.currentDataBaseUsed;
    this.jsonFormSetting = JSON.parse(readTextFile('../../../setting/cashierTrans_1.json'));
    console.log("jsonFormSetting" + this.jsonFormSetting)
    this.initConfrmationFormSave();
    this.cashierTransInit();
    this._userSessionService.getUIState$(UISessionKeys.Transactions).subscribe(state => {
      this.currentTrans = state;
    });
    this.getLoyaltyPointsRedemptionPolicy();
    this._userSessionService.subscribeToKey$('cshBannerData').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.cshBannerData = keys.value;
          this.isVirtual = this.cshBannerData.isVirtual;
          if (this.cshBannerData.currencyChanged == true) {
            this.cashierTransLoad();
            this.setNewReceipt();
          }
        }
      });
    this._userSessionService.subscribeToKey$('invoicePrintingOutPat').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.invoicePrintingOutPat = keys.value;
        }
      });
    if (this.transType != 39 && this.transType != 63) {

      this._userSessionService.subscribeToKey$('selectedPatient')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
          if (keys.value) {
            this.selectedPatient = keys.value;
            this.documentLookupCode = 76
            this.visaValue = 0;
            this.chequeValue = 0;
            this.tableRowId = this.selectedPatient.patCode
            if (this.selectedPatient && this.selectedPatient.visitSerial && this.selectedPatient.patCode) {

              this.getCashierTransData();
            }
          }
        });
    }
    else if (this.transType == 39 || this.transType == 63) {
      this._userSessionService.subscribeToKey$('benfParms').pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
          if (keys.value) {
            this.valueOfCashReceived = 0;
            this.benf = keys.value;
            this.getCashierTransData();
            this.cashierTransForm.get('cashAmmount').setValue(this.benf.value);
          }
        });
    }



    this._userSessionService.subscribeToKey$('SecLoginPrivileges').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          this.partialyPaymentPrev = keys.value[0]['partialyPaymentPrev'];
        }
      });

    this._userSessionService.setSessionKey('receiptSerial', null);

    this.activeCashierStepper$();
    this.observeModal$();
  }
selectAll(e:any,arr :any )
{
  arr.forEach(ele => ele['disabled'] = e)
}
  // active stepper after changes
  activeCashierStepper$() {
    this._userSessionService.setBtnCtrl(this.btnCtrl);
    if (this.stepperComponent) {
      this.stepperComponent.getCurrentStep().pipe(
        takeUntil(this.ngUnsubscribe))
        .subscribe((step: any) => {
          if (step && step.serial == this.myStepNumber) {
            if (this.cshBannerData && this.selectedPatient && this.selectedPatient.visitSerial) {
            }
            this._userSessionService.setBtnCtrl(this.btnCtrl);
          }
        })
    }
  }
  observeModal$() {
    this._userSessionService.getModalKey$().pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'CashierTransComponent' && keys.inputs) {
          if (this.cshBannerData && this.selectedPatient && this.selectedPatient.visitSerial) {
            this.setNewReceipt();
          }
        }
      });
  }
  setNewReceipt() {
    this.cashierTransForm.reset();
    this.checkDiscountValidity();
    //////////////////////////////////
    this.SettleBankTransformerValue = 0
    this.bankTransformerDetailArray = []
    if (this.BankTrans) {
      this.BankTrans.nativeElement.checked = false;
    }
    this.showBankTrans = false;
    this.payWithDoc = false;
    this.totalPayedValue = null;
    ///////////////////////////////////////
    this.setCurrentDairy();
    this.chequeValue = 0;
    this.visaValue = 0;
    this.cshSettlement = [];
    this.discountType = 1;
    this._userSessionService.setSessionKey('chequeParms', {});
    this._userSessionService.setSessionKey('visaParms', {});
    this.showDiscount = false;
    this.showDownPayment = false;
    this.showCopon = false
    this.offerDiscount = false
    if (this.getDataFlag) {
      this.notPayedVisit = [];
      this.remainingFromOtherVisits = <any>{}
      this.notPayedServices = [];
      this.notPayedItems = [];
      this.totalServices = <any>{};
      this.totalItems = <any>{};
      this.GetNotPayedVisitServices(this.selectedPatient.visitSerial, this.factor);
    }
  }
  payedValueEntered() {
    const processPayments = (items, totalEntity) => {
      let percentDiscountFromEveryItem = 0;
      let totalServiceDiscount = 0;
      let totalPayedValue = 0;
      let totalRemainingPrice = 0;
      let totalAfterDiscount = 0;
      let totalPatVat = 0;

      if (+this.totalPayedValue > 0) {
        percentDiscountFromEveryItem = (+this.totalPayedValue) / (+totalEntity.totalPayedValue);
        console.log("percentDiscountFromEveryItem =", percentDiscountFromEveryItem);

        items.forEach((item, i) => {
          item.bufferedPayedValue = item.payedValue;
          item['discountValueForEachSer'] = Math.ceil((+item.payedValue) * percentDiscountFromEveryItem);
          console.log('CustomServiceCode = ', item.customServiceCode, '___', 'discountValueForEachSer = ' + item['discountValueForEachSer'])

          if ((item['discountValueForEachSer'] + totalServiceDiscount) <= this.totalPayedValue) {
            totalServiceDiscount += item['discountValueForEachSer'];
            item.payedValue = item['discountValueForEachSer'];
          } else {
            item.payedValue = (this.totalPayedValue - totalServiceDiscount);
          }

          item.remainingPrice = item.valueAfterDiscount - item.payedValue;
          totalPatVat += (+item.patVat);
          totalAfterDiscount += (+item.valueAfterDiscount);
          totalPayedValue += (+item.payedValue);
          totalRemainingPrice += (+item.remainingPrice);
        });
      } else {
        items.forEach((item, i) => {
          item.payedValue = (+item.bufferedPayedValue);
          item.valueAfterDiscount = (+item.bufferedPayedValue);
          item.remainingPrice = 0;
          totalPatVat += (+item.patVat);
          totalAfterDiscount += (+item.valueAfterDiscount);
          totalPayedValue += (+item.payedValue);
          totalRemainingPrice += (+item.remainingPrice);
        });
      }

      totalEntity.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      totalEntity.totalPayedValue = +totalPayedValue.toFixed(2);
      totalEntity.totalRemainingPrice = +totalRemainingPrice.toFixed(2);
      totalEntity.totalPatVat = +totalPatVat.toFixed(2);
      this.cashierTransForm.get('cashAmmount').setValue(totalEntity.totalPayedValue);
    };

    if (this.notPayedServices.length > 0) {
      processPayments(this.notPayedServices.filter(el=>el.disabled ==false), this.totalServices);
    } else if (this.notPayedItems.length > 0) {
      processPayments(this.notPayedItems.filter(el=>el.disabled ==false), this.totalItems);
    }
  }
  checkDiscountValidity() {
    // clear discount validation
    this.cashierTransForm.get('discountType').clearValidators();
    this.cashierTransForm.get('percentOrValue').clearValidators();
    this.cashierTransForm.get('discountValue').clearValidators();
    this.cashierTransForm.get('cshDiscountsCode').clearValidators();
    // update discount validation
    this.cashierTransForm.get('discountType').updateValueAndValidity();
    this.cashierTransForm.get('percentOrValue').updateValueAndValidity();
    this.cashierTransForm.get('discountValue').updateValueAndValidity();
    this.cashierTransForm.get('cshDiscountsCode').updateValueAndValidity();
  }



  getCashierTransData() {

    if ((this.selectedPatient.patCode || this.benf.benfCode) && this.getDataFlag) {
      this.cashierTransLoad();
    }
    if (this.selectedPatient.visitSerial && this.factor && this.getDataFlag) {
      this.GetNotPayedVisitServices(this.selectedPatient.visitSerial, this.factor);
    }
    if ((this.transType == 39 || 63) && this.factor && this.getDataFlag) { // بيع للجمهور
      this.GetNotPayedVisitServices(-1, this.factor);
    }
  }

  setCurrentDairy() {
    //format date to set current date
    if (this.transDate != undefined || this.transDate != '') {
      this.cashierTransForm.get('transDate').setValue(this.transDate);
      this.cashierTransForm.get('transDateNgb').setValue(this._dateService.convertFromDateToNgBsObject(this.transDate));
    }
  }

  // initialize cashier Trans form
  cashierTransInit() {
    this.cashierTransForm = new UntypedFormGroup({
      serial: new UntypedFormControl(),
      transType: new UntypedFormControl(),
      transDate: new UntypedFormControl('', Validators.required),
      transDateNgb: new UntypedFormControl(),
      benfCode: new UntypedFormControl(),
      benfType: new UntypedFormControl(),
      visitSerial: new UntypedFormControl(),
      cashAmmount: new UntypedFormControl('', positiveNumber),
      chequeAmmount: new UntypedFormControl({ value: '', disabled: false }, positiveNumber,),
      visaAmmount: new UntypedFormControl('', positiveNumber),
      totalAdvancePayment: new UntypedFormControl(),
      settleAdvancePayment: new UntypedFormControl(),
      netAdvancePayment: new UntypedFormControl(),
      cashierId: new UntypedFormControl(),
      cshCurrencyCode: new UntypedFormControl(),
      cshCurrencyFactor: new UntypedFormControl(),
      parentReceipt: new UntypedFormControl(),
      discountType: new UntypedFormControl(),
      percentOrValue: new UntypedFormControl(),
      discountValue: new UntypedFormControl(),
      cshDiscountsCode: new UntypedFormControl(),
      cancelReceiptNumber: new UntypedFormControl(),
      returnSecLoginId: new UntypedFormControl(),
      cshCancelationReasonsCode: new UntypedFormControl(),
      cancelationNotes: new UntypedFormControl(),
      cshBankStpCode: new UntypedFormControl(),
      couponAmmount: new UntypedFormControl(),
      anotherSettlement: new UntypedFormControl(),
      handReceipt: new UntypedFormControl(),
      remainingFromOtherVisits: new UntypedFormControl(),
      settleBankTransformer: new UntypedFormControl(),
      residual: new UntypedFormControl(),
      executedByDocId: new UntypedFormControl(),
      dollarRate: new UntypedFormControl(),
      notes: new UntypedFormControl(),
      memoDoc: new UntypedFormControl(),
      notifCode: new UntypedFormControl(),
      totalLoyaltyPoint: new UntypedFormControl(),
      settlmentLoyaltyPoint: new UntypedFormControl(),
      totalMemosValue: new UntypedFormControl(),
      memoNotes: new UntypedFormControl(),
    });
  }


  // get some cashier trans properties according to cashierParms and secLogin
  cashierTransLoad() {
    this.cashierCode = this.cshBannerData.cshCode;
    this.currencyCode = this.cshBannerData.currencyCode;
    this.factor = this.cshBannerData.factor;
    this.userId = this.cshBannerData.userId;
    this.transDate = this.cshBannerData.transDate;
    // set default for discounTypeSelectize
    this.discounTypeObject = {
      code: this.cshBannerData.discountType,
      nameAr: this.cshBannerData.discountTypeAr,
      nameEn: this.cshBannerData.discountTypeEn
    };
    // set default for percentOrValueSelectize
    this.percentOrValueObject = {
      code: this.cshBannerData.pvCode,
      nameAr: this.cshBannerData.pvNameAr,
      nameEn: this.cshBannerData.pvNameEn
    };
    this.cashierTransForm.reset();
    this.setCurrentDairy();
    if (this.selectedPatient.totalLoyaltyPoint && (+this.selectedPatient.totalLoyaltyPoint) > 0) {
      this.cashierTransForm.get('totalLoyaltyPoint').setValue(this.selectedPatient.totalLoyaltyPoint == 0 ? '' : this.selectedPatient.totalLoyaltyPoint);
  
    }
    
    if (this.selectedPatient.totalAdvancePayment && (+this.selectedPatient.totalAdvancePayment) >= 0) {
      this.setTotalAdvancePayment();
    }
    if (this.benf.totalAdvancePayment && (+this.benf.totalAdvancePayment) >= 0) {
      this.setTotalAdvancePaymentForSellToPublic();
    }
  }
  // init form Confromation popup
  initConfrmationFormSave() {
    this.confirmationPopupForm = this._fb.group({
      code: new UntypedFormControl(),
      cash: new UntypedFormControl(),
      cheque: new UntypedFormControl(),
      visa: new UntypedFormControl(),
    });
  }


  // Set Total Advance Payment
  setTotalAdvancePayment() {
    this.cashierTransForm.get('totalAdvancePayment').setValue(this.selectedPatient.totalAdvancePayment == 0 ? '' : this.selectedPatient.totalAdvancePayment);
  }
  setTotalAdvancePaymentForSellToPublic() {
    this.cashierTransForm.get('totalAdvancePayment').setValue(this.benf.totalAdvancePayment == 0 ? '' : this.benf.totalAdvancePayment);
  }
  moneyTotalsWithDiscounts = <any>{};
  // get not payed services with specific visitSerial
  GetNotPayedVisitServices(visitSerial: number, currencyFactor: number) {
    this.SettleBankTransformerValue = 0
    this.bankTransformerDetailArray = []
    if (this.BankTrans) {
      this.BankTrans.nativeElement.checked = false;
    }
    this.payWithDoc = false;
    this.showBankTrans = false;
    this.notPayedVisit = [];
    this.notPayedServices = [];
    this.notPayedItems = [];
    this.totalServices = <any>{};
    this.remainingFromOtherVisits = <any>{};
    //  this.showDiscount = false;
    this.totalPayedValue = 0;
    this.totalItems = <any>{};
    let cshParms: CashierParms = <CashierParms>{ visitSerial: visitSerial, currencyFactor: currencyFactor, cashierCode: this.cashierCode };
    if ((this.transType == 39 || this.transType == 63) && this.benf) {
      cshParms.transSerial = this.benf.transSerial ? this.benf.transSerial : this.benf.tranSerial;
    }
    if (this.getDataFlag) {
      this.getDataFlag = false
      this._cashierTransService.GetNotPayedVisitServices(cshParms).
        pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          v => {
            if (v) {
              if (v.data && v.data.length > 0) {
                this.notPayedVisit = v.data;
                this.notPayedServices = this.notPayedVisit.filter(S => S.customServiceCode != null)
                this.notPayedCouponServices = this.notPayedVisit.filter(S => S.customServiceCode != null)
                this.notPayedItems = this.notPayedVisit.filter(S => S.itemCode != null);

              }
              if (v.data1 && v.data1.length > 0) {
                this.totalServices = v.data1[0];
              }
              if (v.data2 && v.data2.length > 0) {
                this.totalItems = v.data2[0];
              }
              if (v.data3 && v.data3.length > 0) {
                this.moneyTotalsWithDiscounts = v.data3[0];

              }
              if (v.data4 && v.data4.length > 0) {
                this.remainingFromOtherVisits = v.data4[0];
                this.cashierTransForm.get('remainingFromOtherVisits').setValue(this.remainingFromOtherVisits.remainingPrice)
              }
            }
          },
          error => console.log(error),
          () => {
            this.notPayedCouponServices = this.setcloneArray(this.notPayedServices, this.notPayedCouponServices)
            if ((this.totalServices && this.totalServices.totalPayedValue) || (this.totalItems && this.totalItems.totalPatPrice)) {
              // this.calcCouponamount()
              this.setCashAmmountValue();
            }
            this.totalEnabledValue = (+this.totalServices.totalWantedValue) + (+this.totalItems.totalWantedValue);
            this.totalEnabledPatPrice = (+this.totalServices.totalPatPrice) + (+this.totalItems.totalPatPrice);
            this.getDataFlag = true
            let indx = this.notPayedServices.findIndex(res => res.discountValue > 0);
            if (indx != -1) {
              this.offerDiscount = true
              this.discountType = 2
              if (this.notPayedServices[indx]['cshDiscountsCode'] > 0) {
                this.pvCode = this.notPayedServices[indx]['cshDiscountsCode'];
              }
              this.cashierTransForm.get('discountType').setValue(2);// always by value
              this.cashierTransForm.get('percentOrValue').setValue(2);// always by value
              this.showDiscountOptions(true)
              this.cashierTransForm.get('discountValue').setValue(this.totalServices.totalDiscount);// always by value
            }
            this.notPayedServices.forEach((element, index) => {
              if (element.offerDiscount > 0) {
                this.getRowPriceAfterDiscount(element.offerDiscount, index, 'notPayedServices');
              }
              if (element.discountValue > 0) {
                this.getRowPriceAfterDiscount(element.discountValue, index, 'notPayedServices');
              }
            });


          }
        );
    }


  }
  updateToFixed2() {
    this.notPayedItems.forEach((element, index) => {

      element.wantedToPaied = +element.wantedToPaied.toFixed(2);
      element.payedValue = +element.payedValue.toFixed(2);
      element.valueAfterDiscount = +element.valueAfterDiscount.toFixed(2);
      element.netPrice = +element.netPrice.toFixed(2);
      element.patPrice = +element.patPrice.toFixed(2);
      element.price = +element.price.toFixed(2);

    });
    this.notPayedServices.forEach((element, index) => {

      element.wantedToPaied = +element.wantedToPaied.toFixed(2);
      element.payedValue = +element.payedValue.toFixed(2);
      element.valueAfterDiscount = +element.valueAfterDiscount.toFixed(2);
      element.netPrice = +element.netPrice.toFixed(2);
      element.patPrice = +element.patPrice.toFixed(2);
      element.price = +element.price.toFixed(2);

    });
  }

  // exclude service from paying
  RowDisabled(notPayedService, index: number) {
    notPayedService['disabled'] = !notPayedService['disabled'];
    if (index > 0) {
      this.notPayedCouponServices[index]['disabled'] = !this.notPayedCouponServices[index]['disabled']
    }
    this.GetTotalPayedPrice(-1);
  }

  // calculate total patPrice after changes
  GetTotalPayedPrice(index?: number) {
    this.totalEnabledValue = (+this.totalServices.totalWantedValue) + (+this.totalItems.totalWantedValue);
    this.totalEnabledPatPrice = (+this.totalServices.totalPatPrice) + (+this.totalItems.totalPatPrice);

    if (this.notPayedServices && this.notPayedServices.length > 0) {
      this.getPayedPriceAfterChanges(this.notPayedServices, 'notPayedServices', index);
    }
    if (this.notPayedItems && this.notPayedItems.length > 0) {
      this.getPayedPriceAfterChanges(this.notPayedItems, 'notPayedItems', index);
    }

    if (this.cashierTransForm.get('discountType').value == 2) {
      this.setDiscountValue(true);
    }
    if (this.showDownPayment == true) {
      this.getSettleValue();
    }
    if (this.showCopon == true) {
      this.calcCouponamount();
    }
    this.setCashAmmountValue();
  }

  // update values

  getPayedPriceAfterChanges(notPayed: any[], arrName: string, index?: number) {
    let totalPayedValue = 0;
    let totalRemainingPrice = 0;
    let totalAfterDiscount = 0;
    let totalPatVat = 0;

    for (let j = 0; j < notPayed.length; j++) {
      if (notPayed[j].disabled == true) {
        this.totalEnabledValue = (this.totalEnabledValue - notPayed[j].wantedToPaied);
      }
    }

    for (let i = 0; i < notPayed.length; i++) {
      if (notPayed[i].disabled == true) {
        notPayed[i].remainingPrice = null;
        notPayed[i].payedValue = notPayed[i].valueAfterDiscount;
        totalAfterDiscount += (+notPayed[i].valueAfterDiscount);
        continue;
      }
      if (index == -1) {
        if (!notPayed[i].disabled || notPayed[i].disabled == false) {
          if (this.cashierTransForm.get('discountType').value == 1) {
            if (this.cashierTransForm.get('discountValue').value > 0) {
              notPayed[i].discountValue = +this.discountVal;
              //percent
              if (this.cashierTransForm.get('percentOrValue').value == 1) {
                notPayed[i].valueAfterDiscount = notPayed[i].payedValue =
                  (notPayed[i].wantedToPaied - ((notPayed[i].wantedToPaied * +this.discountVal) / 100)).toFixed(2);
              }

              //value
              if (this.cashierTransForm.get('percentOrValue').value == 2) {
                notPayed[i].valueAfterDiscount = notPayed[i].payedValue =
                  (notPayed[i].wantedToPaied - ((notPayed[i].wantedToPaied * (+this.discountVal / this.totalEnabledValue)))).toFixed(2);
              }
            }
          }
        }
      }

      // for change  sayed
      if ((!notPayed[i].disabled || notPayed[i].disabled == false) && this.calculatVatOnPayed == 1) {
        //select ( 5.6 - (5.6 / (1 +  (15.00 /100) )))
        notPayed[i].patVat = (notPayed[i].payedValue - ((notPayed[i].payedValue / (1 + (notPayed[i].vatValue / 100))))).toFixed(2);
        if (notPayed[i]['vadExceptionFlag'] == 1) {

          notPayed[i].patVat = 0
        }
        notPayed[i].pureVat = (+(notPayed[i].sharedVat) + (+(notPayed[i].patVat))).toFixed(2);


      }
      totalPatVat += (+(notPayed[i].patVat));
      totalAfterDiscount += (+notPayed[i].valueAfterDiscount);
      totalPayedValue += (+notPayed[i].payedValue);
      notPayed[i].remainingPrice = (+notPayed[i].valueAfterDiscount - +(notPayed[i].payedValue)).toFixed(2);
      totalRemainingPrice += (+notPayed[i].remainingPrice);

    }

    if (index >= 0 && notPayed.length > index && +(notPayed[index].payedValue) > +(notPayed[index].valueAfterDiscount)) {
      this.insertCorrectData(this.discountType);
      return;
    }
    if (arrName == 'notPayedServices') {
      this.totalServices.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalServices.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalRemainingPrice = +totalRemainingPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
    }
    if (arrName == 'notPayedItems') {
      this.totalItems.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalItems.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalItems.totalRemainingPrice = +totalRemainingPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
    }
  }

  //-------------------------------------------------# Set form Values ---------------------------------------
  // set cashAmmount value after cheque or visa has changed
  setCashAmmount(key: string, value: number) {
    if (key == 'cheque') {
      this.chequeValue = value;
      this.setCashAmmountValue();
    }
    if (key == 'visa') {
      this.visaValue = value;
      this.setCashAmmountValue();
    }
    if (key == 'Coupon') {
      this.couponValue = value;
      this.setCashAmmountValue();

    }

  }

  // set cashAmmount Value
  setCashAmmountValue() {
    if ((this.totalServices && this.totalServices.totalPayedValue >= 0)
      || (this.totalItems && this.totalItems.totalPayedValue >= 0)
    ) {
      let totalItemsPayedValue = + this.totalItems.totalPayedValue ? this.totalItems.totalPayedValue : 0;
      let totalServicesPayedValue = + this.totalServices.totalPayedValue ? this.totalServices.totalPayedValue : 0;
      if (!(totalServicesPayedValue >= 0)) {
        totalServicesPayedValue = this.clactotalservice();
      }
      if (this.showCopon) {
        totalServicesPayedValue = this.clactotalservice();
      }

      let settleAdvancePayment = (+this.cashierTransForm.get('settleAdvancePayment').value) ? (+this.cashierTransForm.get('settleAdvancePayment').value) : 0
      let settleAdvancePaymentDataBase = this.cashierTransForm.get('totalAdvancePayment').value;
      // sayed copon
      //let couponamount = (+this.cashierTransForm.get('couponAmmount').value);
      let anotherSettlement = (+this.cashierTransForm.get('totalMemosValue').value);
      this.cashierTransForm.get('anotherSettlement').setValue(+anotherSettlement);

      if (settleAdvancePayment > settleAdvancePaymentDataBase) {
        this._toastService.activateMsg('UI13');
        this.cashierTransForm.get('settleAdvancePayment').setValue('');
        settleAdvancePayment = 0;
        return -1
      }
      this.cashierTransForm.get('cashAmmount').setValue(((+totalServicesPayedValue) + (+totalItemsPayedValue) - (+settleAdvancePayment) - (+this.chequeValue) - (+this.visaValue) - (this.SettleBankTransformerValue) - (anotherSettlement)));

    }



  }
  // set Discount Value when discount type is (in detail)
  setDiscountValue(callFromDetail: boolean) {
    this.cashierTransForm.get('discountValue').setValue('');
    let serviceDiscountValue = 0;
    let itemDiscountValue = 0;
    if (this.showDiscount == true && this.discountType == 2 && callFromDetail == true) {
      if (this.totalServices) {
        serviceDiscountValue = +(
          ((+this.totalServices.totalWantedValue) - (+this.totalServices.totalAfterDiscount)) == 0 ?
            null : (((+this.totalServices.totalWantedValue) - (+this.totalServices.totalAfterDiscount))).toFixed(2));
      }
      if (this.totalItems) {
        itemDiscountValue = +(
          ((+this.totalItems.totalWantedValue) - (+this.totalItems.totalAfterDiscount)) == 0 ?
            null : (((+this.totalItems.totalWantedValue) - (+this.totalItems.totalAfterDiscount))).toFixed(2));
      }
      let discountValue = (+serviceDiscountValue) + (+itemDiscountValue);

      this.cashierTransForm.get('discountValue').setValue(discountValue == 0 ? '' : discountValue);
    }
    this.FillDiscountValueForSaleToPublic(this.transType);
  }



  // set Discount Type
  setDiscountType() {
    if (this.discountType && this.showDiscount == true)
      this.cashierTransForm.get('discountType').setValue(this.discountType, { emitEvent: false });
    this.cashierTransForm.get('cshDiscountsCode').setValue(this.pvCode);
    this.setDiscountVPselectizeCode();
  }

  // set discount value
  setDiscountVPselectizeCode() {
    if (this.showDiscount == true && this.discountVal == null) {
      if (this.discountType == 1 && !this.percentOrValue) {
        this.percentOrValue = this.percentOrValueObject.code;
      }
      if (this.discountType == 2 && !this.percentOrValue) {
        this.percentOrValue = 2;
      }
    }
    this.cashierTransForm.get('percentOrValue').setValue(this.percentOrValue)
    this.FillDiscountValueForSaleToPublic(this.transType);
  }

  //----------------------------------------------------------------------------------------------------------------

  // check box for appearing settle advance payment
  showSettleAdvancePayment(cheked: boolean) {
    this.showDownPayment = cheked;
    const settleAdvancePayment = this.cashierTransForm.get('settleAdvancePayment');
    if (cheked == true) {
      settleAdvancePayment.setValidators(Validators.required);
      settleAdvancePayment.setValidators(positiveNumber);
      this.getSettleValue();
    }
    else if (cheked == false) {
      settleAdvancePayment.clearValidators();
      this.cashierTransForm.get('settleAdvancePayment').setValue(null);
    }
    settleAdvancePayment.updateValueAndValidity();
    this.setCashAmmountValue();
  }
  // get settle value
  getSettleValue() {
    if (this.selectedPatient.totalAdvancePayment <= ((+this.totalServices.totalPayedValue) + (+this.totalItems.totalPayedValue))) {
      this.cashierTransForm.get('settleAdvancePayment').setValue(this.selectedPatient.totalAdvancePayment);
    }
    // بيع جمهور
    else if (this.benf.totalAdvancePayment <= ((+this.totalServices.totalPayedValue) + (+this.totalItems.totalPayedValue))) {
      this.cashierTransForm.get('settleAdvancePayment').setValue(this.benf.totalAdvancePayment);
    }
    else {
      this.cashierTransForm.get('settleAdvancePayment').setValue((+this.totalServices.totalPayedValue) + (+this.totalItems.totalPayedValue));
    }
  }

  //change settle value
  changeSettleValue() {
    this.setCashAmmountValue();
  }

  //------------------------------------------------ #discount in total--------------------------------------------

  // check box for appering discount options
  showDiscountOptions(checked: boolean) {
    this.showDiscount = checked;
    const discountType = this.cashierTransForm.get('discountType');
    const pv = this.cashierTransForm.get('percentOrValue');
    const discountVal = this.cashierTransForm.get('discountValue');
    const discountDiscription = this.cashierTransForm.get('cshDiscountsCode');
    if (checked == true) {

      discountType.setValidators(Validators.required);
      pv.setValidators(Validators.required);
      discountVal.setValidators(Validators.required);
      discountDiscription.setValidators(Validators.required);
      if (!this.showCopon && !this.offerDiscount) {
        this.getDataFlag = true
        this.GetNotPayedVisitServices(this.transType == (39 || 63) ? -1 : this.selectedPatient.visitSerial, this.factor);

      }
      if (!this.offerDiscount) {
        this.discountType = this.discounTypeObject.code;
      }
      this.setDiscountType();
      this.percentOrValue = this.discountType;



    }
    if (checked == false) {
      // clear discount validation
      discountType.clearValidators();
      pv.clearValidators();
      discountVal.clearValidators();
      discountDiscription.clearValidators();

      // reset discount columns
      if (!this.showCopon && !this.offerDiscount) {
        this.getDataFlag = true
        this.GetNotPayedVisitServices(this.transType == (39 || 63) ? -1 : this.selectedPatient.visitSerial, this.factor);
      }
      this.discountType = 1;
      this.discountVal = null;
      this.setDiscountType();
      this.setDiscountValue(false);
      this.discountDiscriptionSelectize.clear();
      this.cashierTransForm.get('cshDiscountsCode').setValue(null);
    }
    // update discount validation
    discountType.updateValueAndValidity();
    pv.updateValueAndValidity();
    discountVal.updateValueAndValidity();
    discountDiscription.updateValueAndValidity();
    this.FillDiscountValueForSaleToPublic(this.transType);
  }

  FillDiscountValueForSaleToPublic(transType: number) {

    if ((transType == 39 || transType == 63) && this.moneyTotalsWithDiscounts) {
      //this.moneyTotalsWithDiscounts
      this.cashierTransForm.get('discountType').setValue(1);// always by value
      this.cashierTransForm.get('percentOrValue').setValue(2);// always by value
      this.cashierTransForm.get('discountValue').setValue(this.moneyTotalsWithDiscounts.totalSaleDiscountValue);// always by value
      this.cashierTransForm.get('cshDiscountsCode').clearValidators();
      if (this.cashierTransForm.get('discountValue').value > 0) {
        this.showDiscount = true;
      }
    }

  }
  IsSaleToPublicFlag = false;
  // discount type selectize clicked
  onDiscountTypeSelectizeClicked(discountTypeItem: any) {
    if (discountTypeItem && discountTypeItem['AutoEmited'] == false) {
      this.discountType = discountTypeItem.code;
      this.restDiscountAria();

    }
  }

  // discount type called
  discountTypeCalled(discountType: number) {
    if (discountType) {
      this.discountType = discountType;
      this.restDiscountAria();

    }
  }

  // reset discount area
  restDiscountAria() {
    this.discountVal = null;
    this.pvCode = null;
    this.percentOrValue = null;
    this.getDataFlag = true
    this.GetNotPayedVisitServices(this.transType == (39 || 63) ? -1 : this.selectedPatient.visitSerial, this.factor);
    this.setDiscountType();
    this.setDiscountVPselectizeCode();
    this.setDiscountValue(false);
    this.percentOrValueSelectize.clearItems();
    this.FillDiscountValueForSaleToPublic(this.transType);
  }
  // percent / value selectize clicked
  onPVSelectizeClicked(pvItem: any) {
    if (pvItem && pvItem['AutoEmited'] == false) {
      this.percentOrValue = pvItem.code;
      this.setDiscountVPselectizeCode();
      if (this.discountVal)
        this.onDiscount(this.discountVal, pvItem.code);
    }
  }

  // value changed
  onDiscountValueChanged(val: number) {
    this.discountVal = val;
    if (this.percentOrValue)
      this.onDiscount(val, this.percentOrValue);
  }


  // change type or value
  onDiscount(discountPercent: number, pvType: number) {

    if (this.notPayedServices && this.notPayedServices.length > 0) {
      this.onDiscountChanges(discountPercent, pvType, this.notPayedServices, 'notPayedServices');
    }
    if (this.notPayedItems && this.notPayedItems.length > 0) {
      this.onDiscountChanges(discountPercent, pvType, this.notPayedItems, 'notPayedItems');
    }

    if (this.showDownPayment == true) {
      this.getSettleValue();
    }

    this.setCashAmmountValue();
  }

  onDiscountChanges(discountPercent: number, pvType: number, notPayed: any[], arrName: string) {
    let vadExceptionFlag = notPayed[0].vadExceptionFlag
    let totalAfterDiscount = 0;
    let totalPayedValue = 0;
    let totalPatPrice = 0;
    let totalPatVat = 0;
    for (let i = 0; i < notPayed.length; i++) {
      if (notPayed[i].disabled == true) {
        totalAfterDiscount += (+notPayed[i].valueAfterDiscount);
        totalPayedValue += 0;
        continue;
      }

      notPayed[i].discountValue = discountPercent;
      notPayed[i].remainingPrice = null;
      // for change  sayed
      notPayed[i].patPrice = (+notPayed[i].oldPatPrice)

      // percent
      if (pvType == 1) {
        if (discountPercent > 100) {
          this.insertCorrectData(1);
          return;
        }

        notPayed[i].patPrice = ((+notPayed[i].patPrice) - (+(notPayed[i].patPrice * (discountPercent / 100)))).toFixed(2);
        notPayed[i].patVat = (+(notPayed[i].patPrice * (notPayed[i].vatValue / 100))).toFixed(2);
        notPayed[i].pureVat = (+(notPayed[i].sharedVat) + (+(notPayed[i].patVat))).toFixed(2);
        if (vadExceptionFlag == 1) {

          notPayed[i].patVat = 0
        }

        notPayed[i].valueAfterDiscount = notPayed[i].payedValue = (+(notPayed[i].patPrice) + (+(notPayed[i].patVat))).toFixed(2)
        notPayed[i].discountPrecent = +discountPercent
        notPayed[i].payedValue = +notPayed[i].valueAfterDiscount - notPayed[i].lastPayed
        notPayed[i].valueAfterDiscount = +notPayed[i].valueAfterDiscount - notPayed[i].lastPayed

      }
      //value
      if (pvType == 2) {
        if (discountPercent > this.totalEnabledValue) {
          this.insertCorrectData(1);
          return;
        }
        //notPayed[i].patPrice = (notPayed[i].patPrice - discountPercent).toFixed(2);
        notPayed[i].patPrice = (notPayed[i].patPrice - (notPayed[i].patPrice * (+discountPercent / +this.totalEnabledPatPrice))).toFixed(2);

        // new vat
        notPayed[i].patVat = (+(notPayed[i].patPrice * (notPayed[i].vatValue / 100))).toFixed(2);

        notPayed[i].pureVat = (+(notPayed[i].sharedVat) + (+(notPayed[i].patVat))).toFixed(2);
        if (vadExceptionFlag == 1) {
          notPayed[i].patVat = 0
        }

        notPayed[i].valueAfterDiscount = notPayed[i].payedValue = (+(notPayed[i].patPrice) + (+(notPayed[i].patVat))).toFixed(2);
        notPayed[i].discountPrecent = +((discountPercent / +(this.totalEnabledPatPrice)) * 100)
        notPayed[i].payedValue = +notPayed[i].valueAfterDiscount - notPayed[i].lastPayed
        notPayed[i].valueAfterDiscount = +notPayed[i].valueAfterDiscount - notPayed[i].lastPayed

      }
      totalAfterDiscount += (+notPayed[i].valueAfterDiscount);
      totalPayedValue += (+notPayed[i].payedValue);
      totalPatPrice += (+ notPayed[i].patPrice);
      totalPatVat += (+(notPayed[i].patVat));


    }
    if (arrName == 'notPayedServices') {
      this.totalServices.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalServices.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
      this.totalServices.totalRemainingPrice = 0;
    }
    if (arrName == 'notPayedItems') {
      this.totalItems.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalItems.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
      this.totalItems.totalRemainingPrice = 0;
    }
  }

  //-------------------------------------------------#endregion---------------------------------------------------

  //-----------------------------------------------#discount in detail----------------------------------------

  // row percent/value selectize clicked
  onPvRowClicked(row: any, index: number, arrName: string) {
    if (row && row['AutoEmited'] == false) {
      if (row == null) {
        if (arrName == 'notPayedServices') {
          this.getpriceAfterDiscount(2, 0, index, arrName);
          this.notPayedServices[index].discountValue = null;
        }
        if (arrName == 'notPayedItems') {
          this.getpriceAfterDiscount(2, 0, index, arrName);
          this.notPayedItems[index].discountValue = null;
        }
      }
      else if (index >= 0) {
        if (arrName == 'notPayedServices') {
          if (this.notPayedServices[index].discountValue > 0) {
            this.notPayedServices[index].percentOrValueType = row.code;
            this.getpriceAfterDiscount(row.code, this.notPayedServices[index].discountValue, index, arrName)
          }
        }
        if (arrName == 'notPayedItems') {
          if (this.notPayedItems[index].discountValue > 0) {
            this.notPayedItems[index].percentOrValueType = row.code;
            this.getpriceAfterDiscount(row.code, this.notPayedItems[index].discountValue, index, arrName)
          }
        }
      }
    }

  }

  // row discountValue changed
  getRowPriceAfterDiscount(serviceDiscountvalue: number, index: number, arrName: string) {
    if (+serviceDiscountvalue >= 0 && index >= 0) {
      if (arrName == 'notPayedServices') {
        if (+this.notPayedServices[index].percentOrValueType > 0) {
          this.getpriceAfterDiscount(this.notPayedServices[index].percentOrValueType, serviceDiscountvalue, index, arrName)
        }
      }
      if (arrName == 'notPayedItems') {
        if (+this.notPayedItems[index].percentOrValueType > 0) {
          this.getpriceAfterDiscount(this.notPayedItems[index].percentOrValueType, serviceDiscountvalue, index, arrName)
        }
      }
    }
    this.changeLoyaltyPointSettleValue();
  }

  // get prices after (row discountValue changed) or (row percent/value selectize clicked)
  getpriceAfterDiscount(pvType: number, serviceDiscountvalue: number, index: number, arrName: string) {
    if (arrName == 'notPayedServices' && this.notPayedServices && this.notPayedServices.length > 0) {
      this.getpriceAfterDiscountChanges(pvType, serviceDiscountvalue, index, this.notPayedServices, arrName);
    }
    if (arrName == 'notPayedItems' && this.notPayedItems && this.notPayedItems.length > 0) {
      this.getpriceAfterDiscountChanges(pvType, serviceDiscountvalue, index, this.notPayedItems, arrName);
    }
    if (!this.offerDiscount)
      this.setDiscountValue(true);

    if (this.showDownPayment == true) {
      this.getSettleValue();
    }
    this.setCashAmmountValue();
  }
  // sayed Edition for Calculate  discount  and Vate
  getpriceAfterDiscountChanges(pvType: number, serviceDiscountvalue: number, index: number, notPayed: any[], arrName: string) {
    let totalAfterDiscount = 0;
    let totalPayedValue = 0;
    let totalPatPrice = 0;
    let totalPatVat = 0;
    let vadExceptionFlag = notPayed[0].vadExceptionFlag
    notPayed[index].patPrice = (+notPayed[index].oldPatPrice)
    notPayed[index].remainingPrice = null;
    if (pvType == 1) { //percent
      if (serviceDiscountvalue > 100) {
        this.insertCorrectData(2);
        return;
      }
      notPayed[index].patPrice = ((+notPayed[index].patPrice) - (+(notPayed[index].patPrice * (serviceDiscountvalue / 100)))).toFixed(2);
      notPayed[index].patVat = (+(notPayed[index].patPrice * (notPayed[index].vatValue / 100))).toFixed(2);
      notPayed[index].pureVat = (+(notPayed[index].sharedVat) + (+(notPayed[index].patVat))).toFixed(2);
      if (vadExceptionFlag == 1) {

        notPayed[index].patVat = 0
      }
      notPayed[index].valueAfterDiscount = notPayed[index].payedValue = (+(notPayed[index].patPrice) + (+(notPayed[index].patVat))).toFixed(2)
      // discount Precent
      notPayed[index].discountPrecent = +serviceDiscountvalue
      notPayed[index].payedValue = +notPayed[index].valueAfterDiscount - notPayed[index].lastPayed
      notPayed[index].valueAfterDiscount = +notPayed[index].valueAfterDiscount - notPayed[index].lastPayed

    }
    if (pvType == 2) { // value
      if (serviceDiscountvalue > notPayed[index].wantedToPaied) {
        this.insertCorrectData(2);
        return;
      }
      notPayed[index].patPrice = (notPayed[index].patPrice - serviceDiscountvalue).toFixed(2);
      // new vat
      notPayed[index].patVat = (+(notPayed[index].patPrice * (notPayed[index].vatValue / 100))).toFixed(2);

      notPayed[index].pureVat = (+(notPayed[index].sharedVat) + (+(notPayed[index].patVat))).toFixed(2);
      if (vadExceptionFlag == 1) {
        notPayed[index].patVat = 0
      }
      notPayed[index].valueAfterDiscount = notPayed[index].payedValue = (+(notPayed[index].patPrice) + (+(notPayed[index].patVat))).toFixed(2)
      notPayed[index].discountPrecent = +((serviceDiscountvalue / notPayed[index].oldPatPrice) * 100)
      notPayed[index].payedValue = +notPayed[index].valueAfterDiscount - notPayed[index].lastPayed
      notPayed[index].valueAfterDiscount = +notPayed[index].valueAfterDiscount - notPayed[index].lastPayed
    }

    for (let i = 0; i < notPayed.length; i++) {

      totalAfterDiscount += (+notPayed[i].valueAfterDiscount);

      if (notPayed[i].disabled == true) {
        totalPayedValue += 0;
        continue;
      }

      totalPayedValue += (+notPayed[i].payedValue);
      totalPatPrice += (+ notPayed[i].patPrice);
      totalPatVat += (+(notPayed[i].patVat));

    }
    if (arrName == 'notPayedServices') {
      this.totalServices.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalServices.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
    }
    if (arrName == 'notPayedItems') {
      this.totalItems.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalItems.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
    }
  }

  //-------------------------------------------------#endregion---------------------------------------------------

  insertCorrectData(discountType: number) {
    this.discountTypeCalled(discountType);
    this._toastService.activateMsg('UI13');
    this.showSettleAdvancePayment(false);
  }


  //-------------------------------------------------#region popup------------------------------------------------

  //-------------------------Cheque Popup----------------------
  chequeDetail(chequeValue: number, chequeDetailPopup) {

    // open pupup if the input has a value
    if (chequeValue.toString() == '' || chequeValue == undefined || chequeValue <= 0)
      return;
    this.cashierParms.chequeValue = chequeValue;
    this.cashierParms.value = chequeValue
    this.cashierParms.documentLookupCode = this.documentLookupCode;
    this.cashierParms.serial = -1;
    this.cashierParms.chequeType = 1;
    this.dynamicComponent = ChequeDetailComponent;
    this.content.openModal("ChequeDetailComponent", "chequeParms", this.cashierParms);

  }

  cancelChequePopup(c: any) {
    this._userSessionService.setSessionKey('chequeDetail', <CashierParms>{});
    this.cashierTransForm.get('chequeAmmount').setValue('');
    this.chequeValue = 0;
    this.setCashAmmountValue();
    c('Close click');

  }

  openChequeModal(chequeDetailPopup: any): void {
    this._ngbModal.open(chequeDetailPopup)
      .result.then((result) => { }
        , (reason) => { }
      );
  }

  //-------------------------Visa Popup----------------------
  visaDetail(visaValue: number, visaDetailPopup) {

    // open pupup if the input has a value
    if (visaValue.toString() == '' || visaValue == undefined || visaValue <= 0)
      return;

    this.cashierParms.visaValue = visaValue;
    // set visaValue in visaDetail popup
    this._userSessionService.setSessionKey('visaParms', this.cashierParms);
    this.openVisaModal(visaDetailPopup);
    this.visaValue = 0;
  }

  cancelVisaPopup(c: any) {
    this._userSessionService.setSessionKey('visaDetail', <CashierParms>{});
    this.cashierTransForm.get('visaAmmount').setValue('');
    this.visaValue = 0;
    this.setCashAmmountValue();
    c('Close click');
  }
  cancelCouponPopup(c: any) {
    if (!(this.couponValue > 0)) {
      this._userSessionService.setSessionKey('couponDetail', <CashierParms>{});
      this.cashierTransForm.get('couponAmmount').setValue('');
      this.couponValue = 0
    }
    this.calcCouponamount()
    c('Close click');
  }
  onCouponPopupClose(event) {
    this.cashierTransForm.get('couponAmmount').setValue(event);
    this.couponValue = event
    this.calcCouponamount()

  }
  calcCouponamount() {
    this.notPayedServices = this.setcloneArray(this.notPayedCouponServices, this.notPayedServices)
    let totalAfterDiscount = 0;
    let totalPayedValue = 0;
    let totalPatPrice = 0;
    let totalPatVat = 0;
    if (this.couponValue > 0 && this.showCopon) {
      var couponPatPercentVal: number = 0
      var totalPatServicePrice = this.clactotalservice();
      couponPatPercentVal = +(this.couponValue / totalPatServicePrice)
      this.notPayedServices.forEach(service => {
        if (!service.disabled) {
          let sercouponPat = +(service.patPrice * couponPatPercentVal).toFixed(2)
          service.patPrice = +(service.patPrice - sercouponPat).toFixed(2)
          service.sharedPrice = +(service.netPrice - service.patPrice).toFixed(2)
          // service.sharedPrice = +(service.sharedPrice + sercouponPat).toFixed(2)
          service.serviceCoupon = sercouponPat;
          service.valueAfterDiscount = +(service.valueAfterDiscount - sercouponPat).toFixed(2)
          service.wantedToPaied = +(service.wantedToPaied - sercouponPat).toFixed(2)
          service.payedValue = +((+service.payedValue) - sercouponPat).toFixed(2)
          totalPayedValue += (+service.payedValue);
          totalPatPrice += (+service.patPrice);
          totalPatVat += (+(service.patVat));
          totalAfterDiscount += (+service.valueAfterDiscount);
        }
      });

      this.setCashAmmountValue();
    } else {
      this.notPayedServices = this.setcloneArray(this.notPayedCouponServices, this.notPayedServices)
      this.notPayedServices.forEach(service => {
        totalPayedValue += (+service.payedValue);
        totalPatPrice += (+service.patPrice);
        totalPatVat += (+(service.patVat));
        totalAfterDiscount += (+service.valueAfterDiscount);
      });
      this.totalServices.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalServices.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);

    }
    this.setCashAmmountValue();
    if (this.couponValue > 0 && this.showCopon) {
      this.totalServices.totalAfterDiscount = +totalAfterDiscount.toFixed(2);
      this.totalServices.totalPayedValue = +totalPayedValue.toFixed(2);
      this.totalServices.totalPatPrice = +totalPatPrice.toFixed(2);
      this.totalServices.totalPatVat = +totalPatVat.toFixed(2);
    }
  }
  clactotalservice(): number {
    let totalServiceprice: number = 0
    this.notPayedServices.forEach(element => {
      if (!element.disabled) {
        totalServiceprice += element.patPrice
      }
    });
    if (totalServiceprice > 0) {
      return totalServiceprice
    } else {
      return 0
    }

  }
  setcloneArray(items: any[], cloneArray: any[]): any[] {
    cloneArray = []
    items.forEach(element => {
      cloneArray.push(Object.assign({}, element))
    });
    return cloneArray
  }
  openCouponPopup(couponDetailPopup: any): void {
    this._ngbModal.open(couponDetailPopup)
      .result.then((result) => { }
        , (reason) => { }
      );
  }

  //nada
  LoyaltyRedemptionObject: LoyaltyPointsRedemptionPolicy = <LoyaltyPointsRedemptionPolicy>{};
  sumofDisVal: number  ;
  disres:number;
  settlmentLoyaltyPointVal:number;
  changeLoyaltyPointSettleValue()
  {
    this.sumofDisVal = 0;
    this.notPayedServices.forEach(c => {
      if(c.submissivetoLoyaltyPoints==1){
        c.disVal = +(c.oldPatPrice) - (+c.patPrice) - ((+c.serviceCoupon) ? (+c.serviceCoupon) : 0) ;
        
        this.sumofDisVal += (+c.disVal);
        }
    });
    this.notPayedItems.forEach(x => {
      if(x.submissivetoLoyaltyPoints==1){
      x.disVal = +(x.oldPatPrice) - (+x.patPrice) - ((+x.serviceCoupon) ? (+x.serviceCoupon) : 0) ;
      this.sumofDisVal+=x.disVal;
      }
    }); 

    if(this.sumofDisVal>0)
      this.settlmentLoyaltyPointVal = ((this.sumofDisVal*this.LoyaltyRedemptionObject.countOfPoints)/this.LoyaltyRedemptionObject.valueOfPoints);
    this.cashierTransForm.get('settlmentLoyaltyPoint').setValue(this.settlmentLoyaltyPointVal.toFixed(0));
  }
  
  
  getLoyaltyPointsRedemptionPolicy() {
    this._LoyaltyPointsRedemptionPolicyService.getLoyaltyPointsRedemptionPolicy(this.LoyaltyRedemptionObject)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        if ((res && res.data && res.data.length > 0)) {
          this.LoyaltyRedemptionObject = res.data[0] 
        }
      })

  }
  LoyaltyPointDetail(){
    this.showLoyaltyPoint = !this.showLoyaltyPoint
    
    this.showDiscount =this.showLoyaltyPoint;
    const discountType = this.cashierTransForm.get('discountType');
    const pv = this.cashierTransForm.get('percentOrValue');
    const discountVal = this.cashierTransForm.get('discountValue');
    const discountDiscription = this.cashierTransForm.get('cshDiscountsCode');
    if (this.showLoyaltyPoint) {
      //this.getLoyaltyPointsRedemptionPolicy();
      discountType.setValidators(Validators.required);
      pv.setValidators(Validators.required);
      discountVal.setValidators(Validators.required);
      discountDiscription.setValidators(Validators.required);
      pv.setValue(2);
      discountType.setValue(2);
       
      this.disres = this.LoyaltyRedemptionObject.discountReason;
      discountDiscription.setValue(this.disres);
      this.discountType = 2; 
      this.activatePublicSaleDiscount = 2;
      
    }
    else{
      discountType.clearValidators();
      pv.clearValidators();
      discountVal.clearValidators();
      discountDiscription.clearValidators();
      this.discountType = 1; 
      this.activatePublicSaleDiscount = 1;
         
    } 
    this.setCashAmmountValue();
    if (this.showLoyaltyPoint) {
    this.notPayedServices.forEach((element, index) => { 
      if(element.submissivetoLoyaltyPoints==1)
      {
        element.percentOrValueType = 2;
        element.disableServiceOrItem = true;
      }
    });
    this.notPayedItems.forEach((element, index) => {
      if(element.submissivetoLoyaltyPoints==1)
        {
          element.percentOrValueType = 2;
          element.disableServiceOrItem = true;
        } 
    });
  }
  }
  couponDetail(couponDetailPopup) {
    this.showCopon = !this.showCopon
    if (this.showCopon) {
      this.openCouponPopup(couponDetailPopup);
    } else {
      this.cashierTransForm.get('couponAmmount').setValue('');
      this._userSessionService.setSessionKey('couponDetail', <CashierParms>{});
      this.couponValue = 0
      this.calcCouponamount();
      this.setCashAmmountValue();

    }
  }

  openVisaModal(visaDetailPopup: any): void {
    this._ngbModal.open(visaDetailPopup)
      .result.then((result) => { }
        , (reason) => { }
      );
  }
  //-------------------------------------------------#endregion----------------------------------------------------


  //-----------------------------------------------#region Crud operations-----------------------------------------

  onClicked(e: number): void {
    switch (e) {
      case 1: //save code
      case -1000: //save code
        this.save();
    }
  }



  // save a new recipt and update not payed services remaining Price
  save() {
    if ((this.cashierCode == undefined || this.cashierCode == null)
      && (this.userId == undefined || this.userId == null)) {
      this._toastService.activateMsg('UI45');
      return;
    }
    // not payed services
    if (!this.selectedPatient.visitSerial && this.transType != 39 && this.transType != 63) {
      this._toastService.activateMsg('UI8');
      return;
    }
    if (this.notPayedServices.length == 0 && this.notPayedItems.length == 0) {
      this._toastService.activateMsg('UI9');
      return;
    }
    if (this.selectedPatient.totalLoyaltyPoint < this.settlmentLoyaltyPointVal  ) {
      this._toastService.activateMsg('UI525');
      return;
    }

    this.payedServices = [];
    //----------------------------------------------------------------------------------------------------------------------
    let validServicesArray: boolean;
    let validItemsArray: boolean;
    validServicesArray = this.validatePayedServicesAndItems(this.notPayedServices, 'notPayedServices');
    if (validServicesArray == true) {
      validItemsArray = this.validatePayedServicesAndItems(this.notPayedItems, 'notPayedItems');
    }
    else {
      return;
    }
    if (validItemsArray == false) {
      return;
    }
    //----------------------------------------------------------------------------------------------------------------------

    if (this.payedServices.length == 0) {
      this._toastService.activateMsg('UI12');
      return;
    }

    if (this.currencyCode == undefined || this.currencyCode == null) {
      this._toastService.activateMsg('UI94');
      return;
    }

    // recipt form
    this.cashierTransForm.get('visitSerial').setValue(this.transType == (39 || 63) ? null : this.selectedPatient.visitSerial);
    this.editCashierTrans = this.cashierTransForm.value;
    if (this.isVirtual == 1 || this.transType == 63) {
      this.editCashierTrans.transDate = this._dateService.convertFromNgBsToDate(this.editCashierTrans.transDateNgb);
    }
    this.editCashierTrans.benfCode = this.transType == (39 || 63) ? this.benf.benfCode : this.selectedPatient.patCode;
    this.editCashierTrans.benfType = this.transType == (39 || 63) ? 8 : 1; // (جمهور 8) (1 مريض)
    this.editCashierTrans.cashierId = this.cashierCode;
    this.editCashierTrans.cshCurrencyCode = this.currencyCode;
    this.editCashierTrans.study_ID = this.payedServices[0].study_ID ? this.payedServices[0].study_ID : null
    this.editCashierTrans.cshCurrencyFactor = this.factor;
    this.editCashierTrans.cashierBenfSecLogin = this.userId;

    if (this.transType == 39) {
      this.editCashierTrans.transType = 39
    }
    else if (this.transType == 63) {
      this.editCashierTrans.transType = 63
      this.editCashierTrans.cashierBenfSecLogin = this.cashierTransForm.get('returnSecLoginId').value ? this.cashierTransForm.get('returnSecLoginId').value : this.userId;
      this.editCashierTrans.returnSecLoginId = this.cashierTransForm.get('returnSecLoginId').value ? this.cashierTransForm.get('returnSecLoginId').value : this.userId;
    } else {
      this.editCashierTrans.transType = 1;
    }
    if (this.cashierTransForm.get('anotherSettlement').value > 0) {
      let cshSettlementobj: CshSettlement = <CshSettlement>{};
      cshSettlementobj.serial = -1;
      cshSettlementobj.benfCode = this.cashierTransForm.get('memoDoc').value;
      cshSettlementobj.benfType = 6;
      cshSettlementobj.value = this.cashierTransForm.get('anotherSettlement').value;
      cshSettlementobj.notifCode = this.cashierTransForm.get('notifCode').value;
      this.cshSettlement.push(cshSettlementobj);
    }
    this.editCashierTrans.transType = this.transType > 0 ? this.transType : 1;

    if (this.editCashierTrans.serial == null)
      this.editCashierTrans.serial = 0;

    // cheque Detail Array
    this.chequeDetailArray = [];
    if (this.editCashierTrans.chequeAmmount && this.editCashierTrans.chequeAmmount > 0) {
      this.chequeDetailArray.push(this._userSessionService.getSessionKey<any>('chequeDetail'));
    }

    // visa Detail Array
    this.visaDetailArray = [];
    if (this.editCashierTrans.visaAmmount && this.editCashierTrans.visaAmmount > 0) {
      this.visaDetailArray = this._userSessionService.getSessionKey<any>('visaDetail');
    }
    this.couponDetailArray = []

    if (this.editCashierTrans.couponAmmount && this.editCashierTrans.couponAmmount > 0) {
      this.couponDetailArray = this._userSessionService.getSessionKey<any>('couponDetail');
    }
    let cshBankTransformerLogArray: cshBankTransformerLog[] = [];
    if (this.bankTransformerDetailArray.length > 0) {
      let cshBankTransformerLogObj: cshBankTransformerLog = <cshBankTransformerLog>{};
      for (let i = 0; i < this.bankTransformerDetailArray.length; i++) {
        cshBankTransformerLogObj = <cshBankTransformerLog>{
          serial: (i + 1) * -1,
          cshCashierTransSerial: null,
          bankTransformerSerial: this.bankTransformerDetailArray[i].serial,
          value: this.bankTransformerDetailArray[i].payedValue,
          remainingValue: this.bankTransformerDetailArray[i].remainingValue
        }
        cshBankTransformerLogArray.push(cshBankTransformerLogObj);
        cshBankTransformerLogObj = <cshBankTransformerLog>{};
      }
    }
    this.editCashierTrans.settlmentLoyaltyPoint  = this.settlmentLoyaltyPointVal;
    // object from 9 interfaces
    this.editCashierTrans.stockTransSerial = this.benf.transSerial ? this.benf.transSerial : this.benf.tranSerial;
    let cashierTransArray: CashierTrans[] = [];
    cashierTransArray.push(this.editCashierTrans);
    let payedReceipt: PayedReceipt = <PayedReceipt>{
      cashierTrans: cashierTransArray,
      payedServices: this.payedServices,
      claimsDetail: [],
      supplierBillsDetail: [],
      docFeesDetail: [],
      inOutVariable: [],
      cshDeductionsDetails: [],
      cshCashierTransCheque: this.chequeDetailArray,
      cshCashierTransVisa: this.visaDetailArray,
      cshCashierTransCoupon: this.couponDetailArray,
      bankTransformerDetailArray: cshBankTransformerLogArray,
      clientBillsDetail: [],
      cshCashierClientDiscountNotifications: [],
      hrempcalcsalary: [],
      cshSettlement: this.cshSettlement
    };
    if (this.showComnfirmationPopUp == 1) {
      this.showDetail(this.editCashierTrans);
      this.payedReceiptWithComnfirmation = {};
      this.payedReceiptWithComnfirmation = payedReceipt;
      return -1
    }
    this.showSave = 0
    this._cashierTransService.addCashierTrans(payedReceipt).pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c) {
          this.showSave = 1;
          if (+this.zatcaSendSettingsFlag == 1) {
            if (!(this.currentDataBaseUsed.includes('test'))) {
              this.saveZatca(c.data1[0])
            }
          }
          if (this.invoicePrintingOutPat == 1) {
            if (c.data1 && c.data1.length > 0 && c.data3[0].patBillSerial < 0) {
              this._userSessionService.setSessionKey('receiptSerial', c.data1[0].receiptSerial);
              if (this.stepperComponent && c.returnFlag == true) {
                this.stepperComponent.gotoNextStep();
              }
            }
            else {
              if (c.data3 && c.data3[0].patBillSerial > 0) {
                this._userSessionService.setSessionKey('patBillSerial', c.data3[0].patBillSerial);
              }
            }
          }
          else {
            if (c.data1 && c.data1.length > 0) {
              this._userSessionService.setSessionKey('receiptSerial', c.data1[0].receiptSerial);
              if (this.stepperComponent && c.returnFlag == true) {
                this.stepperComponent.gotoNextStep();
              }
              this._userSessionService.closeModalKey('CashierTransComponent', c.data1);
            }
            if (c.data3 && c.data3[0].patBillSerial > 0) {
              this._userSessionService.setSessionKey('patBillSerial', c.data3[0].patBillSerial);
            }

          }

          if (this.popUpClose)
            this.popUpClose('saved');
          if (c.returnFlag == true) {
            this._userSessionService.setUIStateAction({ type: UIAction.CommitTrans, payload: this.currentTrans['OutPatCashier'] });
          }

          //sayed
          this.cashierTransForm.get('visaAmmount').setValue(null);
          this.cashierTransForm.get('chequeAmmount').setValue(null);
          this.visaValue = 0;
          this.chequeValue = 0;
          this.setNewReceipt();
          if (this._userSessionService.getModalKey('CashierTransCoverComponent')) {

            this._userSessionService.getModalKey('CashierTransCoverComponent')['inputs'].SaveData = 1;
          }
        }

      }, error => console.log(error),
        () => {
          this.showSave = 1
          this.getDataFlag = true
          this.GetNotPayedVisitServices(this.cashierTransForm.get('visitSerial').value, this.factor)


        });
  }
  saveZatca(obj: any) {
    let reviwElectronicInvoice = [];
    reviwElectronicInvoice.push(obj)
    reviwElectronicInvoice[0].branchId = +this._userSessionService.getSessionKey("DashBoardParms")["branchId"]
    reviwElectronicInvoice[0].reciptNo = reviwElectronicInvoice[0].receiptSerial
    reviwElectronicInvoice[0].PatCodeOrCompanyCode = this.selectedPatient.patCode
    reviwElectronicInvoice[0].invoiceType = "0200000"
    reviwElectronicInvoice[0].transactionType = "388"
    reviwElectronicInvoice[0].TableName = "CshCashierTrans"
    this.CreateXmlAndSignature(reviwElectronicInvoice);
  }
  private CreateXmlAndSignature(ElectroincInvoicDataList: ElectroincInvoicData[]) {
    this._ElectroincInvoiceZatcaService.CreateXmlAndSignature(ElectroincInvoicDataList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          this._toastService.toastMsg("تم بنجاح ارسال الفاتورة للزكاه والدخل", 'الزكاه والدخل', "Info");
        },
        error => console.log(error),
        () => {
        });
  }
  //________________________sayed ____________________________________________________


  showDetail(cashirData) {
    if (this.popuppp) {
      this._ngbModal.open(this.popuppp, { size: "lg" })
        .result.then((result) => { }
          , (reason) => { }
        );
    }
    this._userSessionService.setSessionKey('confirmationFormsave', cashirData);
  }
  cancelConfrimationPopup(close?: any) {
    this._userSessionService.subscribeToKey$('confirmationFormsave')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'confirmationFormsave' && keys.value) {
          // console.log()

          // console.log(keys.value)
        }
      });
    close('Close click');
  }

  onConfrimationPopupSave(close?: any) {
    if (this.confirmationPopupForm.get('cheque').value) {
      if (this.editCashierTrans.chequeAmmount > + this.confirmationPopupForm.get('cheque').value) {
        this._toastService.activateMsg('UI13');
        return -1
      }
    }
    if (this.confirmationPopupForm.get('visa').value) {
      if (this.editCashierTrans.visaAmmount > + this.confirmationPopupForm.get('visa').value) {
        this._toastService.activateMsg('UI13');
        return -1
      }
    }
    if (this.confirmationPopupForm.get('cash').value) {
      if (this.editCashierTrans.cashAmmount > + this.confirmationPopupForm.get('cash').value) {
        this._toastService.activateMsg('UI13');
        return -1
      }
    }
    this.showSave = 0
    this._cashierTransService.addCashierTrans(this.payedReceiptWithComnfirmation).pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c) {

          this.showSave = 1;
          if (c.data1 && c.data1.length > 0) {
            this._userSessionService.setSessionKey('receiptSerial', c.data1[0].receiptSerial);
            if (this.stepperComponent && c.returnFlag == true) {
              this.stepperComponent.gotoNextStep();
            }
            this._userSessionService.closeModalKey('CashierTransComponent', c.data1);
          }

          if (this.popUpClose)
            this.popUpClose('saved');
          if (c.returnFlag == true) {
            this._userSessionService.setUIStateAction({ type: UIAction.CommitTrans, payload: this.currentTrans['OutPatCashier'] });
          }

          close('Close click');

          this.confirmationPopupForm.reset();
        }

      }, error => console.log(error),
        () => {
          this.showSave = 1
          this.getDataFlag = true
          this.GetNotPayedVisitServices(this.cashierTransForm.get('visitSerial').value, this.factor)
        });

  }
  //__________________________________________________________________
  validatePayedServicesAndItems(notPayed: any[], arrName: string): boolean {
    for (var i = 0; i < notPayed.length; i++) {
      if (notPayed[i].disabled == true)
        continue;
      if (+notPayed[i].payedValue < 0) {
        this._toastService.activateMsg('UI11', notPayed[i].serial);
        return false;
      }
      if (notPayed[i].remainingPrice < 0
        || (notPayed[i].payedValue < 0 && notPayed[i].wantedToPaied != 0)
        || notPayed[i].payedValue.toString() == '') {
        this._toastService.activateMsg('UI13', notPayed[i].serial);
        return false;
      }
      if (this.cashierTransForm.get('discountType').value == 2) {
        if (notPayed[i].percentOrValue
          && (notPayed[i].discountValue == undefined ||
            notPayed[i].discountValue == null)

          || (notPayed[i].discountValue
            && (notPayed[i].percentOrValueType == undefined ||
              notPayed[i].percentOrValueType == null))) {
          this._toastService.activateMsg('WARNINGDISCOUNTTYPEVALUE', notPayed[i].serial);
          return false;
        }
      }
      var payedService: PayedServices = {
        serial: notPayed[i].serial,
        type: arrName == 'notPayedServices' ? 1 : 2,  // 1 for service and 2 for item
        payed: +notPayed[i].remainingPrice == 0 ? 1 : 2,
        payedValue: notPayed[i].payedValue,
        remainingPrice: notPayed[i].remainingPrice,
        discountValue: notPayed[i].discountValue,
        percentOrValue: this.cashierTransForm.get('discountType').value == 1 ? this.cashierTransForm.get('percentOrValue').value : notPayed[i].percentOrValueType,
        disVal: +(notPayed[i].oldPatPrice) - (+notPayed[i].patPrice) - ((+notPayed[i].serviceCoupon) ? (+notPayed[i].serviceCoupon) : 0),
        // disVal: +(notPayed[i].oldPatPrice) - (+notPayed[i].patPrice),
        vatValue: notPayed[i].vatValue,
        serviceCoupon: notPayed[i].serviceCoupon,
        pureVat: notPayed[i].pureVat,
        requestDocId: notPayed[i].requestDocId,
        billItem: notPayed[i].billItem,
        itemOrServiceCode: notPayed[i].itemOrServiceCode,
        cashCharge: notPayed[i].cashCharge,
        regPatServiceSerial: notPayed[i].regPatServiceSerial,
        executedByDocId: this.cashierTransForm.get('executedByDocId').value,
        discountPrecent: notPayed[i].discountPrecent,
        comingFrom: notPayed[i].comingFrom,
        fixedConsumerValue: notPayed[i].fixedConsumerValue,
        study_ID: notPayed[i].study_ID
      };
      this.payedServices.push(payedService);
    }
    return true;
  }
  setDetail(key: string, value: number) {
    if (key && value && value.toString() != '' && value != 0) {
      if (key == 'bankTrans') {
        this.popupHeader = 'BANKTRANSFERE';

        let bankTransParms = <any>{
          totalValue: this.cashierTransForm.get('cashAmmount').value
          , benfCode: this.selectedPatient.patCode
          , benfType: 1 //pa
          , transType: 1 //wa
          , currencyCode: this.currencyCode //wa
          , factor: this.factor //w
        };
        this.dynamicComponent = BankTransformerDiscountComponent;
        this.content.openModal("BankTransformerDiscountComponent", "bankTransParms", bankTransParms);
      }
    }
  }
  hasBankTrans(check: boolean) {
    this.showBankTrans = check;
    if (check == true) {
      this.setDetail('bankTrans', -1);
    }
    if (check == false) {
      this.BankTrans.nativeElement.checked = false;
      this.cashierTransForm.get('settleBankTransformer').setValue(null);
      this.SettleBankTransformerValue = 0;
      this.setCashAmmountValue();
    }


  }
  onpopupClose(parms: any) {

    if (parms && parms.output == 'Cross click') {
      if (parms.name == "BankTransformerDiscountComponent") {
        this.BankTrans.nativeElement.checked = false;
        this.cashierTransForm.get('settleBankTransformer').setValue(null);
        this.SettleBankTransformerValue = 0;
        this.bankTransformerDetailArray = [];
        this.setCashAmmountValue();
      }
    }
    else if (parms && parms.name == "BankTransformerDiscountComponent" && parms.output) {

      this.bankTransformerDetailArray = parms.output;
      this.SettleBankTransformerValue = 0
      for (let i = 0; i < this.bankTransformerDetailArray.length; i++) {
        this.SettleBankTransformerValue += (+this.bankTransformerDetailArray[i].payedValue);
      }
      this.cashierTransForm.get('settleBankTransformer').setValue(this.SettleBankTransformerValue);
      this.setCashAmmountValue();
    }

  }
  openCheque: number = 1;
  moduleId: number;
  zatcaSendSettingsFlag: number = 0

  currentDataBaseUsed: string;
  getModuleSettings() {
    this.activatePublicSaleDiscount = 2;
    this.PossibilityPartialPayment = 1;
    this._userSessionService.subscribeToKey$('link')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(link => {
        if (link.name = 'link') {
          this.stockSettingsParms.moduleId = 48
          this._userSessionService.subscribeToKey$('modulesSettings')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
              if (keys.value) {
                this.mediclaModuleSettings = keys.value[`m_${this.stockSettingsParms.moduleId}`];
                this.showComnfirmationPopUp = this.mediclaModuleSettings['confirmationPopup'];
                this.calculatVatOnPayed = this.mediclaModuleSettings['calculatVatOnPayed'];
                this.openCheque = +this.mediclaModuleSettings['openCheque'];
                this.activatePublicSaleDiscount = this.mediclaModuleSettings['activatePublicSaleDiscount'] ? this.mediclaModuleSettings['activatePublicSaleDiscount'] : 2;
                this.PossibilityPartialPayment = this.mediclaModuleSettings['PossibilityPartialPayment'] ? this.mediclaModuleSettings['PossibilityPartialPayment'] : 1;
                this.zatcaSendSettingsFlag = keys.value[`m_14278`]['ZatcaSendPatientInvoiceDynamic']

              }
            });
          if (!this.mediclaModuleSettings || !this.showComnfirmationPopUp || !this.PossibilityPartialPayment) {
            this._cashierTransService.getStockModuleSettings(this.stockSettingsParms)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.mediclaModuleSettings = c.data[0];
                  if (this.mediclaModuleSettings) {
                    this.showComnfirmationPopUp = this.mediclaModuleSettings['confirmationPopup'];
                    this.calculatVatOnPayed = this.mediclaModuleSettings['calculatVatOnPayed'];
                    this.openCheque = +this.mediclaModuleSettings['openCheque'];
                    this.activatePublicSaleDiscount = this.mediclaModuleSettings['activatePublicSaleDiscount'] ? this.mediclaModuleSettings['activatePublicSaleDiscount'] : 2;
                    this.PossibilityPartialPayment = this.mediclaModuleSettings['possibilityPartialPayment'] ? this.mediclaModuleSettings['possibilityPartialPayment'] : 1;
                    console.log('x', this.showComnfirmationPopUp)
                  }
                }
              });
          }
        }
      });
  }
  showChequePopup(value: Boolean, chequeDetailPopup) {
    if (value) {
      let chequeValue = this.cashierTransForm.get('cashAmmount').value
      this.cashierTransForm.get('chequeAmmount').setValue(chequeValue)
      this.setCashAmmount('cheque', chequeValue)
      this.chequeDetail(chequeValue, chequeDetailPopup);
      this.cashierTransForm.get('cashAmmount').setValue(0);
      this.chequeCheckBox.nativeElement.checked = false;
    }

  }
  showVisaPopup(value: boolean, visaDetailPopup) {
    if (value) {
      let visaValue = this.cashierTransForm.get('cashAmmount').value
      this.cashierTransForm.get('cashAmmount').setValue(+0)
      this.cashierTransForm.get('visaAmmount').setValue(visaValue)
      this.setCashAmmount('visa', visaValue);
      this.visaDetail(visaValue, visaDetailPopup);
      this.visaCheckBox.nativeElement.checked = false;
    }
  }

  totalCash: number
  getReceivedforSaleTpublic() {
    this.totalCash = +this.cashierTransForm.get('cashAmmount').value
    if (this.valueOfCashReceived >= this.totalCash) {
      this.cashierTransForm.get('residual').setValue((+this.valueOfCashReceived) - this.cashierTransForm.get('cashAmmount').value)
    } else {
      this.cashierTransForm.get('residual').reset()
    }
  }
  addbankTransfer(value) {
    this._ngbModal.open(this.bankTransFromPopup, { size: "lg" })
      .result.then((result) => { }
        , (reason) => { }
      );
  }
  saveBankTransform() {
    this.bankTranFromerObj.serial = -1;
    this.bankTranFromerObj.transformerType = 1;
    this.bankTranFromerObj.transType = 1;
    this.bankTranFromerObj.currency = this.currencyCode;
    this.bankTranFromerObj.currencyFactor = this.factor;

    this.bankTranFromerObj.transDate = this._dateService.convertFromNgBsToDate(this.bankTranFromerObj.transDate)
    this._BankTransformerService.addBankTransformer(this.bankTranFromerObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(c => {
        if (c && c.returnFlag == true) {
          if (c && c.data && c.data.length > 0) {
            this.bankTranFromerObj = <BankTransformer>{};
          }
        }
      }
      );
  }
  addSetteladvancepayment() {
    this._router.navigate(['/cashier/pettyCashaddAddAdvancePayment', { mode: 4 }])
    this._userSessionService.setSessionKey('link', { code: 5272, mode: 4 });
  }


  getServiceDiscount(item: any) {
    this.dynamicComponent = DiscountServicesRequestComponent;
    this._userSessionService.setSessionKey('DiscountServicesRequest', item)
    this.DiscountServicesRequest.openModal("DiscountServicesRequestComponent", item.serial);
  }

  onpopup2Close(parms: any) {
    parms('Close click');
  }
  //-------------------------------------------------#endregion----------------------------------------------------
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onMemosValueChanged() {
    this.setCashAmmountValue();
  }
  showpayWithDoc(cheked: boolean) {
    this.payWithDoc = cheked;
    if (this.payWithDoc) {
      this.cashierTransForm.get('memoDoc').setValidators(Validators.required);
      this.cashierTransForm.get('notifCode').setValidators(Validators.required);
      this.cashierTransForm.get('totalMemosValue').setValidators(Validators.required);
      this.cashierTransForm.get('memoNotes').setValidators(Validators.required);

    } else {
      this.cashierTransForm.get('memoDoc').clearValidators()
      this.cashierTransForm.get('notifCode').clearValidators();
      this.cashierTransForm.get('totalMemosValue').clearValidators();
      this.cashierTransForm.get('memoNotes').clearValidators();
      this.cashierTransForm.get('memoDoc').setValue(null);
      this.cashierTransForm.get('notifCode').setValue(null);
      this.cashierTransForm.get('totalMemosValue').setValue(null);
      this.cashierTransForm.get('memoNotes').setValue(null);
      this.cashierTransForm.get('cashAmmount').setValue(+this.cashierTransForm.get('anotherSettlement').value);
    } this.cashierTransForm.get('anotherSettlement').setValue(null);
    this.cashierTransForm.get('memoDoc').updateValueAndValidity();
    this.cashierTransForm.get('notifCode').updateValueAndValidity();
    this.cashierTransForm.get('totalMemosValue').updateValueAndValidity();
    this.cashierTransForm.get('memoNotes').updateValueAndValidity();
    this.cashierTransForm.get('memoDoc').setValue(this.notPayedServices[0].visitDocId)
  }
  memoDoc: number
  onDoctorSelectizeClicked(selected: any) {
    if (selected && selected['AutoEmited'] == false) {
      this.memoDoc = selected.code;
    }
  }
  notifCode: number
  onMemoSerialClicked(selected: any) {
    if (selected && selected['AutoEmited'] == false) {
      this.notifCode = selected.code;
    }
  }
}

